<template>
  <router-view/>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style lang="sass">
@import url("https://fonts.googleapis.com/css?family=Noto+Sans+TC:400,700&display=swap&subset=chinese-traditional")

html, body, div, span, applet, object, iframe,
h1, h2, h3, h4, h5, h6, p, blockquote, pre,
a, abbr, acronym, address, big, cite, code,
del, dfn, em, img, ins, kbd, q, s, samp,
small, strike, strong, sub, sup, tt, var,
b, u, i, center,
dl, dt, dd, ol, ul, li,
fieldset, form, label, legend,
table, caption, tbody, tfoot, thead, tr, th, td,
article, aside, canvas, details, embed,
figure, figcaption, footer, header, hgroup,
menu, nav, output, ruby, section, summary,
time, mark, audio, video
  margin: 0
  padding: 0
  border: 0

article, aside, details, figcaption, figure,
footer, header, hgroup, menu, nav, section
  display: block

html, body
  height: 100%
  width: 100%

ol, ul, li
  list-style: none

a
  text-decoration: none
  color: black

*
  font-family: "Noto Sans TC", Arial, sans-serif
  white-space: nowrap

*,
*::before,
*::after
  box-sizing: border-box

::-webkit-scrollbar
  width: 0px

::-webkit-scrollbar-thumb
  background: grey

::-webkit-scrollbar-thumb:hover
  background: rgba(grey,0.5)
</style>
